// Page-level and shared-chrome copy: document titles, landing, not-found, data-load errors, the
// subject header, and small shared components.
export const pagesContent = {
  // Document titles, e.g. "CADY Studios - Home"
  siteName: 'CADY Studios',
  documentTitleTemplate: '##SiteName## - ##PageTitle##',
  homePageTitle: 'Home',
  capGownPageTitle: 'Cap and Gown',
  graduationPageTitle: 'Graduation',
  athleticPageTitle: 'Athletic',
  underclassPageTitle: 'Underclass',
  seniorsPageTitle: 'Seniors',
  seniorPreorderPageTitle: 'Senior Preorder',
  yearbookPageTitle: 'Yearbook',

  // Market landing
  shareLabel: 'Share with your family and friends',
  noImagesMessage:
    "Hmmm. We don't have any images to show you at this time. Check back later or contact customer service.",

  // Not found
  notFoundMessage: "This page doesn't seem to exist.",
  notFoundDetail: 'It looks like the link pointing here was faulty.',
  backToGalleryLabel: 'Back to Gallery',

  // Data load errors
  dataLoadErrorHeading: 'Error loading data',
  dataLoadErrorMessage:
    'There was an error loading the data for this page. Please try again. If the issue persists please contact customer service.',
  siteDownMessage: 'Our ordering site is currently down. Please check back later.',
  tryAgainLabel: 'Try Again',

  // Subject header
  subjectImageAlt: 'Subject Image',
  orderingForLabel: 'Ordering for',

  // Personalization previews
  capGownPreviewAlt: 'Cap and Gown Preview Image',
  graduationPreviewAlt: 'Graduation Preview Image',
  underclassPreviewAlt: 'Underclass Preview Image',

  // Shared chrome
  backToTopLabel: 'Back to top',
  amountSpentLabel: 'Amount Spent',
  pleaseWaitLabel: 'Please wait…'
}
